import React from "react";
import {observer} from "mobx-react";
import {IconButton, Modal, Typography} from "@mui/material";
import styled from "@emotion/styled";
import {useViewController} from "data/services/locator";
import type {IModalErrorController} from "views/components/modals/modal_error/modal_error.controller";
import {Bindings} from "data/constants/bindings";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import {Exist} from "views/components/exist/exist.component";

const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 16px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: var(--modalBackground);
	padding: 16px 20px 32px;
	border-radius: 4px;
	text-align: center;
	color: #ffffff;
	@media screen and (max-width: 640px) {
		max-width: unset;
		left: 24px;
		right: 24px;
		width: auto;
		transform: translateY(-50%);
	}

	button {
		max-width: 300px;
	}
`;

const CloseBlock = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	button {
		padding: 0;

		svg {
			width: 32px;
			height: 32px;
			color: #fff;
		}
	}
`;

const Icon = styled.div`
	width: 80px;
	color: var(--invalidColor);
	svg {
		width: 100%;
		height: auto;
	}
`;

export const ModalError: React.FC = observer(() => {
	const {isOpen, modalContent, i18n, close} = useViewController<IModalErrorController>(
		Bindings.ModalErrorController
	);

	return (
		<Modal open={isOpen}>
			<ModalContent>
				<CloseBlock>
					<IconButton sx={{minWidth: 0}} onClick={close}>
						<CloseIcon color={"inherit"} />
					</IconButton>
				</CloseBlock>
				<Icon>
					<ErrorIcon />
				</Icon>
				<Typography>
					{i18n.t(modalContent?.title ?? "modal.error.title", "Error")}
				</Typography>
				<Exist when={modalContent?.message}>
					<Typography>{modalContent?.message}</Typography>
				</Exist>
			</ModalContent>
		</Modal>
	);
});
